import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gqrffagxbmccrfomaosq.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdxcmZmYWd4Ym1jY3Jmb21hb3NxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUzMjg4MjYsImV4cCI6MjA1MDkwNDgyNn0.1odDMeRrrtbgRxQj-a23ybdGR0ORQckYdmhQ6PcmqC4";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true
    }
  }
);